import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import Glyphicon from "../Glyphicon";

class InfoWindowOpis extends PureComponent<any> {
  render() {
    const { description } = this.props;
    if (!description) return null;
    return (
      <section className="InfoWindowOpis">
        <Glyphicon className="InfoWindowOpis_icon" icon="info_outline" />
        {description}
      </section>
    );
  }
}

export default InfoWindowOpis;
